import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import Autoglyph from './Autoglyph.js';
import axios from 'axios';
import Slider from '@material-ui/core/Slider';

import Sdot from './images/dot.svg';
import Sback_slash from './images/back_slash.svg';
import Sforward_slash from './images/forward_slash.svg';
import Sh_line from './images/h_line.svg';
import Splus from './images/plus.svg';
import Sround from './images/round.svg';
import Ssquare from './images/square.svg';
import Sv_line from './images/v_line.svg';
import Scross from './images/cross.svg';
import Chevron from './images/chevron.svg';
// component
import Header from './components/Header'
import About from './components/About'
import Select from "react-dropdown-select";
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import logo from './logo.png';


const SymbolSVG = [Sdot, Sround, Sv_line, Sh_line, Sback_slash, Sforward_slash, Scross, Splus, Ssquare]
const API_URL = process.env.REACT_APP_API_URL || "https://api.glyphstats.com/api/";

const muiTheme = createMuiTheme({
	overrides: {
		MuiSlider: {
			thumb: {
				color: "black",
			},
			track: {
				color: 'black'
			},
			rail: {
				color: 'black'
			}
		}
	}
});

const hex_dict = {
	"0x2e": 0,
	"0x4f": 0,
	"0x7c": 0,
	"0x2d": 0,
	"0x5c": 0,
	"0x2f": 0,
	"0x58": 0,
	"0x2b": 0,
	"0x23": 0,
}
let filterValue = [];
let searchData = [];
let dataA = '';
let valuearry = []

let filterValuePattern = [];
let searchDataPattern = [];
let filterValueCluster = [];
let searchDataCluster = []

export default function Dashboard() {

	const [searchAutoglyph, setSearchAutoglyph] = React.useState()
	const [passAutoglyph, setpassAutoglyph] = React.useState()
	const [autoglyph, setAutoglyph] = React.useState([])
	const [, setDefualtAutoglyph] = React.useState([])
	const [pattern, setPattern] = React.useState()
	const [symbol, setSymbol] = React.useState([])
	const [passData, setPassData] = React.useState(false)
	const [defaultDict, setDefaultDict] = React.useState(hex_dict)
	const [responseCount, setResponseCount] = React.useState(0)
	const [loading, setLoading] = React.useState(true)
	const [symmetrySearch, setSymmetrySearch] = React.useState([])
	const [symboleDistribution, setSymboleDistribution] = React.useState([])
	const [symbolSearch, setSymbolSearch] = React.useState('')
	const [searchQuery, setSearchQuery] = React.useState('')
	const [symmetrydata, setSymmetrydata] = React.useState('')
	const [symmetryTitle, setSymmetryTitle] = React.useState()
	const [sortByAutoglyph, setSortByAutoglyph] = React.useState('')
	const [isSidebarSchemeActive, setSidebarSchemeActive] = React.useState(true);
	const [isSidebarSymmetryActive, setSidebarSymmetryActive] = React.useState(false);
	const [isSidebarSymbolActive, setSidebarSymbolActive] = React.useState(false);
	const [isSidebarClusterActive, setSidebarClusterActive] = React.useState(false);
	const [isFiltersActive, setFiltersActive] = React.useState(false);
	const [isAboutActive, setAboutActive] = React.useState(false);
	const [selectedClusterFilter, setSelectedClusterFilter] = useState([])
	const [cluster, setCluster] = useState([])
	const [clusterQuery, setClusterQuery] = useState('')

	useEffect(() => {
		axios.get(API_URL + 'cluster-data/')
			.then(response => {
				setCluster(response.data)
			}).catch(error => {
			})
	}, [])



	const [checkbox, setCheckbox] = React.useState(
		{
			0: false,
			20: false,
			40: false,
			60: false,
			80: false,
			100: false,
		}
	)

	// Symmetry slider marks value updated
	const valueLabelFormat = (value) => {
		let lable = `${value}%`
		return lable
	}

	//Symmetry slider marks
	const marks = [
		{
			value: 0,
			label: 'None',
			title: ['none'],
		},
		{
			value: 20,
			label: 'Diagonal',
			title: ['diagonal_ff_angle', 'diagonal_otf_angle']
		},
		{
			value: 40,
			label: 'Y-axis',
			title: ['y_axes_n_angle']
		},
		{
			value: 80,
			label: 'X-axis',
			title: ['x_axes_oe_angle']
		},
		{
			value: 60,
			label: 'X&Y',
			title: ['x_axes_oe_angle', 'y_axes_n_angle']
		},
		
		{
			value: 100,
			label: 'X,Y,Diagonal',
			title: ['all']
		},

	];

	// const cluster = [
	// 	{
	// 		value: 0,
	// 		label: 'Group 1 (15 Autoglyphs, 17%)',

	// 	},
	// 	{
	// 		value: 20,
	// 		label: 'Group 2 (13 Autoglyphs, 18%)',

	// 	},
	// 	{
	// 		value: 40,
	// 		label: 'Group 3 (13 Autoglyphs, 18%)',

	// 	},
	// 	{
	// 		value: 60,
	// 		label: 'Group 4 (13 Autoglyphs, 18%)',

	// 	},
	// 	{
	// 		value: 80,
	// 		label: 'Group 5 (13 Autoglyphs, 18%)',

	// 	},
	// 	{
	// 		value: 100,
	// 		label: 'Group 6 (13 Autoglyphs, 18%) ',

	// 	},

	// ];

	useEffect(() => {
		let data = []
		axios.get(API_URL + "symmetry/")
			.then(response => {
				data.push(response.data)
				marks.forEach((element) => {
					for (const key in response.data) {
						if (response.data.hasOwnProperty(key)) {
							const self = response.data[key];
							if ((element.label) === key) {
								element.total = self.total
								element.percentage = self.percentage
							}
						}
					}
				});
				setSymmetryTitle(marks)
			})

	}, [])

	const getDefualtAuto = (ag) => {
		setResponseCount(ag.length)
		setAutoglyph(ag);
		setDefualtAutoglyph(ag);
		setLoading(false)
	}

	useEffect(() => {
		const filtersEmpty = !searchQuery && !symmetrydata && !symbolSearch && !sortByAutoglyph && !clusterQuery
		if (filtersEmpty) {
			const cached = sessionStorage.getItem('autoglyphs_default')
			if (cached) {
				const data = JSON.parse(cached)
				setAutoglyph(data)
				setResponseCount(data.length)
				setLoading(false)
				return
			}
		}
		getCallApi()
	}, [searchQuery, symmetrydata, symbolSearch, sortByAutoglyph, clusterQuery])


	const dummyPatterns = [
		{
			id: 1,
			value: 0,
			title: ['1'],
		},
		{
			id: 2,
			value: 20,
			title: ['2'],
		},

		{
			id: 3,
			value: 40,
			title: ['3'],

		},
		{
			id: 4,
			value: 60,
			title: ['4'],
		},
		{
			id: 5,
			value: 80,
			title: ['5'],
		},
		{
			id: 6,
			value: 100,
			title: ['6'],

		},
		{
			id: 7,
			value: 120,
			title: ['7'],
		},
		{
			id: 8,
			value: 140,
			title: ['8'],
		},
		{
			id: 9,
			value: 160,
			title: ['9'],
		},
		{
			id: 10,
			value: 180,
			title: ['10'],
		}

	]


	//Response Of Pattern i.e. Symbol scheme in UI
	useEffect(() => {
		let data = []
		axios.get(API_URL + 'patterns/')
			.then(response => {

				data.push(response.data)
				dummyPatterns.forEach((element) => {
					for (const key in response.data) {

						if (response.data.hasOwnProperty(key)) {
							const self = response.data[key];


							if ((element.id) === response.data[key].pattern_number) {

								element.count = self.count//forEach funnction creates key named total and will assign the corressponding value
								element.actual_percentage = self.actual_percentage
								element.pattern = self.pattern
							}
						}
					}
				})
				setPattern(dummyPatterns)
			});

	}, [])

	//Symbol-distribution-API which is called along with Pattern Select
	useEffect(() => {
		axios.get(`${API_URL}symbol-distribution/?${searchQuery}`)
			.then(response => {
				if (response.data.length > 0) {
					setSymbol(response.data)

					dummySymbol.forEach((element) => {
						for (const key in response.data) {
							if (response.data.hasOwnProperty(key)) {
								const self = response.data[key];
								if ((element.id) === response.data[key].id) {


									element.value[1] = self.value
									element.hex_value = self.hex_value

								}
							}
						}
					})
				}
				setLoading(false)
			})
			.catch(() => {
				setLoading(false)
			});
	}, [searchQuery])


	const [dummySymbol, setDummySymbol] = useState(
		[{
			id: 1,
			value: [
				0, 39
			]
		}, {
			id: 2,
			value: [
				0, 39
			]
		}, {
			id: 3,
			value: [
				0, 39
			]
		},
		{
			id: 4,
			value: [
				0, 39
			]
		},
		{
			id: 5,
			value: [
				0, 39
			]
		},
		{
			id: 6,
			value: [
				0, 39
			]
		},
		{
			id: 7,
			value: [
				0, 39
			]
		},
		{
			id: 8,
			value: [
				0, 39
			]
		},
		{
			id: 9,
			value: [
				0, 39
			]
		}])
	const [selectedPatternFilter, setSelectedPatternFilter] = useState([])
	const [patternChecked, setPatternChecked] = useState(
		{
			0: false,
			1: false,
			2: false,
			3: false,
			4: false,
			5: false,
			6: false,
			7: false,
			8: false,
			9: false
		}
	)
	const handleActiveFilter = (e, index) => {
		setLoading(true)
		let target = e.target;
		let value = target.value;
		let name = target.name;
		let getNumber = '';
		value = value.split(',');
		let getPattern
		pattern.forEach(element => {
			if (Number(name) === element.id) {
				getNumber = element.id;
				getPattern = element.pattern
			}
		});
		// get a checked value
		if (target.checked) {
			setPatternChecked({ ...patternChecked, [getNumber - 1]: true });
			value.forEach((ele) => {
				filterValuePattern.push(ele)
			})
		} else {
			setPatternChecked({ ...patternChecked, [getNumber - 1]: false });
			value.forEach((ele) => {
				filterValuePattern = filterValuePattern.filter(item => item !== ele)
			})
		}
		// get symmetry data
		if (e.target.checked) {
			searchDataPattern.push(e.target.name)
		} else {
			searchDataPattern = searchDataPattern.filter(item => item !== e.target.name)
		}

		var query = Object.entries(searchDataPattern).map(([key, value]) => `${value}`);
		if (query.length === 0) {
			setSearchQuery('')
		} else {
			setSearchQuery(`pattern_id=[${query}]`)
		}

		if (target.checked) {
			setSelectedPatternFilter([...selectedPatternFilter, { id: getNumber, pattern: getPattern }])
		} else {
			let selectRomoveFilter = selectedPatternFilter.filter(ele => ele.id !== getNumber)
			setSelectedPatternFilter(selectRomoveFilter)
			setDummySymbol(dummySymbol)
		}

	}

	const handlePatternFilter = (item) => {
		// e.preventDefault();
		// setSelectedClass()
		// setpassAutoglyph()
		// setSelectedFilters([])
		// setSearchQuery([])
		// setLoading(true)

		var getValue = '';
		pattern.forEach(element => {
			if (item.id === element.id) {
				getValue = item.id;
				pattern.forEach(el => {
					filterValuePattern = filterValuePattern.filter(ele => ele !== el.id)
				});
			}
		})

		setPatternChecked({ ...patternChecked, [getValue - 1]: false });
		searchDataPattern = searchDataPattern.filter(itemA => String(itemA) !== String(item.id))

		var query = Object.entries(searchDataPattern)
			.map(([key, value]) => `${value}`);

		if (query.length === 0) {
			setSearchQuery('')
		} else {
			setSearchQuery(`pattern_id=[${query}]`)
		}
		let selectRomoveFilter = selectedPatternFilter.filter(ele => ele.id !== item.id)
		setSelectedPatternFilter(selectRomoveFilter)
		setLoading(true)
	}

	const handleClusterFilter = (item) => {

		var getValue = '';
		cluster.forEach(element => {
			if (`Group ${item}` === element.group) {
				getValue = item;
				cluster.forEach(el => {

					filterValueCluster = filterValueCluster.filter(ele => `Group ${ele}` !== el.group)
				});
			}
		})

		setClusterChecked({ ...clusterChecked, [getValue - 1]: false });
		searchDataCluster = searchDataCluster.filter(itemA => itemA !== item)
		setSelectedClusterFilter(searchDataCluster)
		var query = Object.entries(searchDataCluster).map(([key, value]) => `${value - 1}`);

		if (query.length === 0) {
			setClusterQuery('')
		} else {
			setClusterQuery(`cluster_number=[${query}]`)
		}

		setLoading(true)

	}


	const gfg = [
		{
			value: 0,
		},
		{
			value: 25,
		},
		{
			value: 50,
		},
		{
			value: 75,
		},
		{
			value: 100,
		},
	];

	const [, setVal] = React.useState([]);

	const updateRange = React.useCallback((e, data, element, hex_value) => {
		setLoading(true)
		setVal(data)
		let objects = [...symbol]
		objects[(element - 1)]['value'] = data;		
		setSymbol(objects)
		let d = defaultDict
		d[hex_value] = data
		setDefaultDict(d)
	}, [symbol])

	const callAPISearch = () => {
		let symobleArry = []
		setLoading(true)
		let data = defaultDict;
		const filtered = Object.entries(data).reduce((acc, [key, value]) => {
			if (value !== 0) {
				acc[key] = value;
			}
			return acc;
		}, {});
		var q = Object.entries(filtered).map(([key, value]) => `${key}=[${value}]`).join('&');
		setSymbolSearch(q)
		dataA = q.split("&")
		dataA.forEach(element => {
			symobleArry.push(element.split("="))
		});
		symobleArry.forEach(ele => {
			symbol.forEach(element => {
				if (ele[0] === element.hex_value) {
					valuearry.push(element)
				}
			});
		})
		// dummydata	
		dummySymbol.forEach((element) => {
			for (const key in symbol) {
				if (symbol.hasOwnProperty(key)) {
					const self = symbol[key];
					if ((element.id) === symbol[key].id) {
						if (self.value.length > 0) {
							element.value = self.value
						} else {
							element.value[1] = self.value
						}
					}
				}
			}
		})
		setDummySymbol(dummySymbol)
		let uniq = [...new Set(valuearry)];
		setSymboleDistribution(uniq)
	}

	// checkbox filter Symmetry add
	const handleChangeFilterCheckbox = (e) => {
		setLoading(true)
		let target = e.target;
		let value = target.value;
		let name = target.name;
		let getNumber = '';
		value = value.split(',');
		marks.forEach(element => {
			if (name === element.label) {
				getNumber = element.value;
			}
		});
		// get a chceked value
		if (target.checked) {
			setCheckbox({ ...checkbox, [getNumber]: true });
			value.forEach((ele) => {
				filterValue.push(ele)
			})
		} else {
			setCheckbox({ ...checkbox, [getNumber]: false });
			value.forEach((ele) => {
				filterValue = filterValue.filter(item => item !== ele)
			})
		}
		// dynamic query
		var query = Object.entries(filterValue)
			.map(([key, value]) => `${value}=1`).join('&');

		// get symmetry data
		if (e.target.checked) {
			searchData.push(e.target.name)
		} else {
			searchData = searchData.filter(item => item !== e.target.name)
		}
		setSymmetrydata(query)

		setPassData(true)
		setSymmetrySearch(searchData)
	}

	// header search
	const callSearchApi = (e) => {
		e.preventDefault()
		setLoading(true)
		setpassAutoglyph(searchAutoglyph)

		axios.get(API_URL + 'search/?autoglyph_id=' + searchAutoglyph)
			.then(response => {

				//Response count is to display header autoglyphs count. 
				setResponseCount(Object.keys(response.data).length)

				// Set autoglyphs based on the latest response data
				setAutoglyph(response.data)
				setLoading(false)

			});
	}

	// Symmetry search remove
	function handlesymmetryFilter(item) {
		var getValue = '';
		marks.forEach(element => {
			if (item === element.label) {
				getValue = element.value;
				element.title.forEach(el => {
					filterValue = filterValue.filter(ele => ele !== el)
				})
			}
		});
		setCheckbox({ ...checkbox, [getValue]: false });
		searchData = searchData.filter(itemA => itemA !== item)
		setSymmetrySearch(searchData)

		var query = Object.entries(filterValue)
			.map(([key, value]) => `${value}=1`).join('&');
		setSymmetrydata(query)

		setLoading(true)
	}

	// symbole Filter
	const handlersymboleFilter = (item) => {
		let removeArry = []
		// var gethexa = item.split('=');
		valuearry = valuearry.filter(el => el !== item)
		let uniqB = [...new Set(valuearry)];
		setSymboleDistribution(uniqB)
		let d = defaultDict
		d[item.hex_value] = 0;
		setDefaultDict(d)
		let uniqA = [...new Set(uniqB)];
		uniqA.forEach(element => {
			let data = `${element.hex_value}=[${element.value}]`
			removeArry.push(data)
		});
		let uniq = [...new Set(removeArry)];
		var q = Object.entries(uniq)
			.map(([key, value]) => `${value}`).join('&');
		q = q === '' ? '' : q;
		setSymbolSearch(q)
		setLoading(true)

	}

	const options = [
		{ value: 'autoglyph(low to high)', label: 'Autoglyph# (low to high)' },
		{ value: 'autoglyph(high to low)', label: 'Autoglyph# (high to low)' },
		{ value: 'Rarity Score(low to high)', label: 'Rarity Score (low to high)' },
		{ value: 'Rarity Score(high to low)', label: 'Rarity Score (high to low)' },
		{ value: 'Symbol Scheme(high to low)', label: 'Symbol Scheme (low to high)' },
		{ value: 'Symbol Scheme(low to high)', label: 'Symbol Scheme (high to low)' },
		{ value: 'Symmetry(common to rare)', label: 'Symmetry(common to rare)' },
		{ value: 'Symmetry(rare to common)', label: 'Symmetry(rare to common)' },
		{ value: 'Symbol Distribution(common to rare)', label: 'Symbol Distribution(common to rare)' },
		{ value: 'Symbol Distribution(rare to common)', label: 'Symbol Distribution(rare to common)' },
	];

	const sortingAutoglyph = (item,response) => {
		let getValue = '';
		let q;
		item.forEach(element => {
			getValue = element.value;
		});
		if (getValue === "autoglyph(low to high)") {
			q = "autoglyph=ascending"
			setLoading(true)
		} else if (getValue === "autoglyph(high to low)") {
			q = "autoglyph=descending"
			setLoading(true)
		} else if (getValue === "Rarity Score(high to low)") {
			q = "rarity_score=ascending"
			setLoading(true)
		} else if (getValue === "Rarity Score(low to high)") {
			q = "rarity_score=descending"
			setLoading(true)
		} else if (getValue === "Symbol Scheme(low to high)") {
			q = "symbol_scheme=ascending"
			setLoading(true)
		} else if (getValue === "Symbol Scheme(high to low)") {
			q = "symbol_scheme=descending"
			setLoading(true)
		} else if (getValue === "Symmetry(common to rare)") {
			q = "symmetry=ascending"
			setLoading(true)
		} else if (getValue === "Symmetry(rare to common)") {
			q = "symmetry=descending"
			setLoading(true)
		} else if (getValue === "Symbol Distribution(common to rare)") {
			q = "symbol_distribution=ascending"
			setLoading(true)
		} else if (getValue === "Symbol Distribution(rare to common)") {
			q = "symbol_distribution=descending"
			setLoading(true)
		}

		if (searchQuery || symbolSearch || symmetrydata || clusterQuery) {
			setSortByAutoglyph(q)
		} else {
			axios.get(API_URL + "sort-by/?" + q)
				.then(res => {
					setAutoglyph(res.data)
					setPassData(true)
					setLoading(false)
				})
		}
	}


	// all search api call
	// function getCallApi() {
	// 	axios.get(API_URL + 'search/?' + `${searchQuery}&${symbolSearch}&${symmetrydata}&${sortByAutoglyph}&${clusterQuery}`)
	// 		.then(response => {
	// 			if (response.data.length > 0) {
	// 				setAutoglyph(response.data)
	// 				setResponseCount(Object.keys(response.data).length)
	// 				setPassData(true)
	// 				setLoading(false)
	// 			} else {
	// 				setAutoglyph(defualtAutoglyph)
	// 				setResponseCount(Object.keys(defualtAutoglyph).length)
	// 				setLoading(false)
	// 			}

	// 		});
	// }
	const [clusterChecked, setClusterChecked] = useState(
		{
			0: false,
			1: false,
			2: false,
			3: false,
			4: false,
			5: false,
			6: false,
			7: false,
			8: false,
			9: false,
			10: false,
			11: false,
			12: false,
			13: false,
			14: false,
			15: false,
			16: false,
			17: false,
			18: false,
			19: false
		}
	)

	const clearAllFilters = () => {
		setSelectedPatternFilter([])
		setPatternChecked({
			0: false, 1: false, 2: false, 3: false, 4: false,
			5: false, 6: false, 7: false, 8: false, 9: false
		})
		setSelectedClusterFilter([])
		setClusterChecked(Object.fromEntries(Array.from({ length: 20 }, (_, i) => [i, false])))
		setClusterQuery('')
		setCheckbox({ 0: false, 20: false, 40: false, 60: false, 80: false, 100: false })
		setSymmetrydata('')
		setSymmetrySearch([])
		setDummySymbol(dummySymbol.map(s => ({ ...s, value: [0, 39] })))
		setSymbolSearch('')
		setSearchQuery('')
		setSortByAutoglyph('')
	}

	// all search api call
	// function getCallApi() {
	// 	axios.get(API_URL + 'search/?' + `${searchQuery}&${symbolSearch}&${symmetrydata}&${sortByAutoglyph}&${clusterQuery}`)
	// 		.then(response => {
	// 			if (response.data.length > 0) {
	// 				setAutoglyph(response.data)
	// 				setResponseCount(Object.keys(response.data).length)
	// 				setPassData(true)
	// 				setLoading(false)
	// 			} else {
	// 				setAutoglyph(defualtAutoglyph)
	// 				setResponseCount(Object.keys(defualtAutoglyph).length)
	// 				setLoading(false)
	// 			}

	// 		});
	// }

	
	// all search api call
	function getCallApi() {

		axios.get(`${API_URL}search/?${searchQuery}&${symbolSearch}&${symmetrydata}&${sortByAutoglyph}&${clusterQuery}`)
			.then(response => {
				if (searchQuery !== '' || symbolSearch !== '' || symmetrydata !== '' || sortByAutoglyph !== '' || clusterQuery !== '') {
					if (response.data.length > 0) {

						let value = [{
							label: "Autoglyph# (low to high)",
							value: "autoglyph(low to high)"
						}]
						if(sortByAutoglyph===''){
						sortingAutoglyph(value, response.data)
						}
						setPassData(true)
						setResponseCount(response.data.length)
						setAutoglyph(response.data)
						setLoading(false)
					} else {
						setResponseCount('0')
						setAutoglyph([])
						setLoading(false)
					}
				} else {
					sessionStorage.setItem('autoglyphs_default', JSON.stringify(response.data))
					setResponseCount(response.data.length)
					setLoading(false)
					setAutoglyph(response.data)
				}
			})
			.catch(() => {
				setResponseCount('0')
				setAutoglyph([])
				setLoading(false)
			});
	}

	const toggleSidebarScheme = () => {
		setSidebarSchemeActive(!isSidebarSchemeActive);
	}

	const toggleSidebarSymmetry = () => {
		setSidebarSymmetryActive(!isSidebarSymmetryActive);
	
	}

	const toggleSidebarSymbol = () => {
		setSidebarSymbolActive(!isSidebarSymbolActive);
	}

	const toggleSidebarCluster = () => {
		setSidebarClusterActive(!isSidebarClusterActive);
	}

	const toggleFilters = () => {
		setFiltersActive(!isFiltersActive);
	}

	const toggleAbout = () => {
		setAboutActive(!isAboutActive);
	}

	const handleClusterCheckboxChange = (e, index) => {

		setLoading(true)
		let target = e.target;
		var value = target.value;
		let name = target.name;
		let getNumber = '';
		value = value.split(',');
		let dummyValue = value
		let a = dummyValue[0]
		cluster.forEach(element => {
			if (`Group ${name}` === element.group) {

				getNumber = a - 1;
			}

		});

		// let value2=value.split(',');
		if (target.checked) {
			setClusterChecked({ ...clusterChecked, [getNumber]: true });
			value.forEach((ele) => {
				filterValueCluster.push(ele)
			})
		} else {
			setClusterChecked({ ...clusterChecked, [getNumber]: false });

			value.forEach((ele) => {
				filterValueCluster = filterValueCluster.filter(item => item !== ele)
			})
		}

		// get symmetry data
		if (e.target.checked) {
			searchDataCluster.push(e.target.name)
		} else {
			searchDataCluster = searchDataCluster.filter(item => item !== e.target.name)
		}

		var query = Object.entries(searchDataCluster)
			.map(([key, value]) =>
				`${value - 1}`);


		if (query === [] || query === '' || query.length===0) {
			setClusterQuery('')
		} else {
			setClusterQuery(`cluster_number=[${query}]`)
		}


		setSelectedClusterFilter(searchDataCluster)
	}

	return (
		<div>

<Header
				setSearchAutoglyph={setSearchAutoglyph}
				callSearchApi={callSearchApi}
				search={true}
				display_searchbar={true} 
				toggleFilters={toggleFilters.bind(this)}
				toggleAbout={toggleAbout.bind(this)}
				buttons={true}
				/>

			<div>
				<div className="container">
					<div className={`column column-a ${isFiltersActive ? "active" : "inactive"}`}>

						<div className="sidebar-mobile-header">
							<div onClick={clearAllFilters}>Clear all</div>
							<div onClick={toggleFilters}>Done</div>
						</div>

						{
							pattern &&
							<div className={`symbole_schema sidebar-filter ${isSidebarSchemeActive ? "active" : "inactive"}`}>
								<div className='sidebar-heading' onClick={(event) => toggleSidebarScheme(event)}>
									<div className="v3_26">Symbol Scheme</div>
									<img src={Chevron} width="16" height="9" className="sidebar-chevron" alt="" />
								</div>
								<div className="sidebar-dropdown">
									{
										pattern.map((item, index) => (

											<div className={`v3_31`} key={index}>
												<input type="checkbox" id={item.value} value={item.title} name={item.id} rel={item.value}
													checked={patternChecked[index]}
													onChange={(e) => handleActiveFilter(e)} />
												<label htmlFor={item.value}>
													#{item.id}
													<img className='v5_453' src={`${item.pattern}`} alt="Symbol scheme" />
													<span className='v4_14'>({item.count}, {`${Math.ceil(item.actual_percentage)}%`})</span>
												</label>
											</div>

										))
									}
								</div>

							</div>
						}
						<div className={`symbole_schema sidebar-filter ${isSidebarSymmetryActive ? "active" : "inactive"}`}>
							<div className='sidebar-heading' onClick={(event) => toggleSidebarSymmetry(event)}>
								<div className="v3_26">Symmetry</div>
								<img src={Chevron} width="16" height="9" className="sidebar-chevron" alt="" />
							</div>
							<div className={`Symmetry-slider sidebar-dropdown`}>
								{
									symmetryTitle && symmetryTitle.map((item, i) => (
										<div className="symmetryTitle_section" key={item.value}>
											<input type="checkbox" id={`sym-${item.value}`} value={item.title} name={item.label} rel={item.value} checked={checkbox[item.value]}
											 onChange={(e) => handleChangeFilterCheckbox(e)}/>
											<label htmlFor={`sym-${item.value}`} className="inner-symmetry">
												{`${item.label}`}
												<p>{`(${item.total}, ${Math.ceil(item.percentage)}%)`}</p>
											</label>
										</div>



									))
								}
							</div>
						</div>
						{
							symbol &&
							<div className={`symbole_schema symbole-distribution-data sidebar-filter ${isSidebarSymbolActive ? "active" : "inactive"}`}>
								<div className='sidebar-heading' style={{zIndex: -100}}onClick={(event) => toggleSidebarSymbol(event)}>
									<div className="v3_26">Symbol Distribution</div>
									<img src={Chevron} width="16" height="9" className="sidebar-chevron" alt="" />
								</div>
								<div className={`filter_list sidebar-dropdown`} >
									{
										dummySymbol.map((item, index) => (

											 Math.round(item.value[1]) !== '0'
											&&
											
														<div className="filter-symbol" style={{marginTop:index===0?'22px':''}}
														key={index}>
															<div className="v3_58">
																<img src={SymbolSVG[index]} className='custom-symbol' alt="" />
																<ThemeProvider theme={muiTheme}>
																	<Slider
																		value={[item.value[0], Math.round(item.value[1])]}
																		onChangeCommitted={callAPISearch}
																		onChange={(event, data, id, hex_value) => updateRange(event, data, item.id, item.hex_value)}
																		marks={gfg}
																		valueLabelFormat={valueLabelFormat}
																		valueLabelDisplay="auto"
																		aria-labelledby="discrete-slider"
																	/>
																</ThemeProvider>

															</div>

															<span className='v4_14'></span>
															<span className='v5_453'></span>
														</div>				  
										))
									}
								</div>

							</div>
						}

						<div className={`symbole_schema cluster-section sidebar-filter ${isSidebarClusterActive ? "active" : "inactive"}`}>
							<div className='sidebar-heading' onClick={(event) => toggleSidebarCluster(event)}>
								<div className="v3_26">Cluster</div>
								<img src={Chevron} width="16" height="9" className="sidebar-chevron" alt="" />
							</div>
							<div className="Symmetry-slider cluster-slide sidebar-dropdown" >
								{
									cluster.map((item, index) => (


										<div className="cluster-row" key={index}>
											<input type="checkbox" id={`cluster-${index}`} value={index + 1} name={index + 1} rel={index}
												checked={clusterChecked[index]}
												onChange={e => handleClusterCheckboxChange(e)} />
											<label htmlFor={`cluster-${index}`}>
												<span className="cluster-group">{item.group}</span>
												<span className="cluster-count">({item.count} Autoglyphs, {`${Math.ceil(item.percentage)}%`})</span>
											</label>
										</div>
									
									))
								}


							</div>
						</div>
					</div>

					<div className="column column-b">

						<div>
							<div className="v4_position_data">
								<div>
									{/* <div className="media-btn"><button onClick={() => OpenFilterSlider()}>Filter</button></div> */}
									<span>{loading ? '...' : responseCount} results</span>
								</div>
								<div className="setting_select_btn">
									<Select
										placeholder="Sort by"
										options={options}
										value={
											options.filter(option => option.label === 'autoglyph(low to high)')
										}
										onChange={(value) => sortingAutoglyph(value)}
									/>
								</div>
							</div>
							<div className="v4_position_sec_inner">
								<div className="v4_sec_search">
									{

										selectedPatternFilter.map((item, index) => {
											return (
												<div className="inner_search_btn_a" key={index} onClick={() => handlePatternFilter(item)}>
													<span>#{item.id}</span>
													<img src={item.pattern} alt={`Symbol #${item.id}`} />
												</div>
											)
										})
									}
								</div>

							  	<div className="v4_sec_search">
									{
										selectedClusterFilter && selectedClusterFilter.map((item, index) => (
											<div className="inner_search_btn" key={index} onClick={() => handleClusterFilter(item)}>
												<span>Group {item}&nbsp;</span>
											</div>
										))
									}
								</div>
								
								<div className="Symmetry_search">
									{
										symmetrySearch && symmetrySearch.map((item, i) => (
											<div className="inner_search_btn" onClick={() => handlesymmetryFilter(item)} key={i}>
												{item}
											</div>
										))
									}
								</div>

								<div className="Symmetry_search">
								{
												symboleDistribution && symboleDistribution.map(item => (
													<div className="inner_search_btn" key={item.hex_value}>
														{
															item.hex_value === "0x2e" ?
																<div className="inner_search_symbole" onClick={() => handlersymboleFilter(item)}>
																	<span><img src={Sdot} alt="" /></span>
																	<span> = {item.value[0]}-{item.value[1] + "%"}</span>
																</div>
																:
																item.hex_value === "0x4f" ?
																	<div className="inner_search_symbole" onClick={() => handlersymboleFilter(item)}>
																		<span><img src={Sround} style={{ filter: 'brightness(0%)' }} alt="" /></span>
																		<span> = {item.value[0]}-{item.value[1] + "%"}</span>
																	</div>
																	:
																	item.hex_value === "0x7c" ?
																		<div className="inner_search_symbole" onClick={() => handlersymboleFilter(item)}>
																			<span><img src={Sv_line} style={{ filter: 'brightness(0%)' }} alt="" /></span>
																			<span> = {item.value[0]}-{item.value[1] + "%"}</span>
																		</div>
																		:
																		item.hex_value === "0x2d" ?
																			<div className="inner_search_symbole" onClick={() => handlersymboleFilter(item)}>
																				<span><img src={Sh_line} style={{ filter: 'brightness(0%)' }} alt="" /></span>
																				<span> = {item.value[0]}-{item.value[1] + "%"}</span>
																			</div>
																			:
																			item.hex_value === "0x5c" ?
																				<div className="inner_search_symbole" onClick={() => handlersymboleFilter(item)}>
																					<span><img src={Sback_slash} style={{ filter: 'brightness(0%)' }} alt="" /></span>
																					<span> = {item.value[0]}-{item.value[1] + "%"}</span>
																				</div>
																				:
																				item.hex_value === "0x2f" ?
																					<div className="inner_search_symbole" onClick={() => handlersymboleFilter(item)}>
																						<span><img src={Sforward_slash} style={{ filter: 'brightness(0%)' }} alt="" /></span>
																						<span> = {item.value[0]}-{item.value[1] + "%"}</span>
																					</div>
																					:
																					item.hex_value === "0x58" ?
																						<div className="inner_search_symbole" onClick={() => handlersymboleFilter(item)}>
																							<span><img src={Scross} style={{ filter: 'brightness(0%)' }} alt="" /></span>
																							<span> = {item.value[0]}-{item.value[1] + "%"}</span>
																						</div>
																						:
																						item.hex_value === "0x2b" ?
																							<div className="inner_search_symbole" onClick={() => handlersymboleFilter(item)}>
																								<span><img src={Splus} style={{ filter: 'brightness(0%)' }} alt="" /></span>
																								<span> = {item.value[0]}-{item.value[1] + "%"}</span>
																							</div>
																							:
																							item.hex_value === "0x23" ?
																								<div className="inner_search_symbole" onClick={() => handlersymboleFilter(item)}>
																									<span><img src={Ssquare} style={{ filter: 'brightness(0%)' }} alt="" /></span>
																									<span> = {item.value[0]}-{item.value[1] + "%"}</span>
																								</div>
																								: ""
														}
													</div>
												))
											}
								</div>
							</div>
						</div>
						{responseCount === '0' ?
							<section className="products" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
								{!loading && <div style={{ border: '1px solid whitesmoke', padding: '10%', marginTop: '5%' }}><h2> No items Found for this search</h2></div>}
							</section> : null}
						{
							passAutoglyph ?
								<section className="products">
									{
										autoglyph.map((item, index) => (
											<Link to={{ pathname: `/autoglyph-details/${item.id}` }} className="product-card" key={item.id}>
												<div className="product-image">

													{loading && <img src={logo} alt="" />}
													{!loading && <img src={`${item.autoglyph_image}`} alt="Autoglyph" loading="lazy" decoding="async" />}
													<div className="product-info">
														{!loading && `Autoglyph #${item.id}`}
													</div>
												</div>
											</Link>
										))}

								</section>
								:

								<span>

									{

										passData ?

											<section className="products">
												{
													autoglyph.map((item, index) => (
														<Link to={{ pathname: `/autoglyph-details/${item.id}` }} className="product-card" key={item.id}>
																<div className="product-info">
																	{!loading && `Autoglyph #${item.id}`}
																</div>
															<div className="product-image">

																{loading && <img src={logo} alt="" />}
																{!loading && <img src={`${item.autoglyph_image}`} alt="Autoglyph" loading="lazy" decoding="async" />}

															
															</div>
															<div className="product-rarity">
											Rarity #{item.rarity_score}
								    	
										</div>

														</Link>
														
													))}

											</section>
											:
											<Autoglyph getDefault={getDefualtAuto} />

									}
								</span>
						}
					</div>

				</div>

			</div>
			<About isActive={isAboutActive} toggleAbout={toggleAbout.bind(this)} />
		</div>
	);

}



// WEBPACK FOOTER //
// ./src/dashboard.js